import createReactComponent from '../createReactComponent';
export default createReactComponent('chart-line', 'ChartLine', [["path",{"d":"M3 16.5 9 10l4 6 8-9.5","key":"svg-0"}]]);